export default "__VITE_ASSET__FTZy$PoJ__"